import { forwardRef } from "react";
import { IconsaxProps } from "./Iconsax.types.js";

export const RecordBold = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7402 20.6099C16.7108 20.6099 20.7402 16.5804 20.7402 11.6099C20.7402 6.6393 16.7108 2.60986 11.7402 2.60986C6.76967 2.60986 2.74023 6.6393 2.74023 11.6099C2.74023 16.5804 6.76967 20.6099 11.7402 20.6099Z"
                    fill="white"
                    style={{ fill: "var(--fillg)" }}
                />
            </svg>
        </div>
    );
});
